import proxyClient from '@/plugins/axios/proxyClient'

export default {
  getCodes() {
    return proxyClient.get('/codes')
  },
}
